import { TeamMemberAccessStatusColorEnum } from 'pages/TeamMembers/Internal/components/TeamMemberAccessStatus/TeamMemberAccessStatus.types';
import {
  TeamMemberPageAvatar,
  TeamMemberToolTip,
} from 'pages/TeamMembers/Internal/components/TeamMemberAvatar/TeamMemberAvatar.styled';
import { Fragment } from 'react';
import { css } from 'styled-components';
import { AccessStatusEnum, AvatarUrl } from 'types/graphql';

export function TeamMemberAvatar(props: {
  avatarUrls: AvatarUrl;
  accessStatus: {
    name: AccessStatusEnum;
  };
  pendingSignup: boolean;
}) {
  const { avatarUrls = { origin: '' }, pendingSignup, accessStatus } = props;
  let accessStatusName = accessStatus?.name;

  return (
    <Fragment>
      <TeamMemberPageAvatar
        src={avatarUrls?.origin as unknown as string}
        width="35px"
        height="35px"
        size={62}
        fallbackAvatarColor={TeamMemberAccessStatusColorEnum['default']}
        accessStatusName={accessStatusName}
        css={css`
          margin-right: 15px;
        `}
        showPendingSignUp={pendingSignup}
      />
      {pendingSignup && <TeamMemberToolTip />}
    </Fragment>
  );
}
